import React, { Component } from "react";
import TrainerImage from "../../Images/trainer.png";
import { Row, Col } from "reactstrap";
import "./style.css";

class Trainer extends Component {
  render() {
    return (
      <div className="trainerConatiner animate__animated animate__fadeIn">
        <div className="trainerText animate__animated animate__fadeInDown">
          <Row>
            <Col> </Col>
            <Col>
              {" "}
              <div className="tc">
                <img src={TrainerImage} alt="Trainer" width="200px" />
                <h4 className="trainerHeading tc">
                  Meet Your Head Trainer At WORK!
                </h4>
              </div>
            </Col>
          </Row>

          <h4 className="trainerHeading tl"> Years At WORK</h4>
          <p className="tc">
           Salman Aslam, started my Career at WORK in 2020 as a Corporate Trainer for Sales
            and Support and lead the Training & Development Department.
          </p>
          <h4 className="trainerHeading tl"> Years In Training </h4>
          <p className="tc">
            I hold 7 years of experience in Telemarketing with most of the
            expertise in training that includes Technical Support, Sales,
            Retention, Cross Sell, Customer Success, Salesforce, Targeted
            Training/Huddles and Organizational Development Programs for
            Upskilling purposes.
          </p>
          <h4 className="trainerHeading tl">How I Got Here </h4>
          <p className="tc">
            I always knew the existence of WORK in the market. My interview with
            our CEO Ali Janjua struck me and I decided to join as soon as I
            could without possibly bringing in any second thoughts.
          </p>
          <h4 className="trainerHeading tl">My Goals As A Head Trainer</h4>
          <p className="tc">
            My goal as a Head Trainer is to create, design, organize, research
            and manage all the training programs currently running in the
            company.
          </p>
        </div>
      </div>
    );
  }
}
export default Trainer;
